<template>
  <AbsoluteLayout :class="classes">
    <ScrollView id="MainScrollView" class="scroll-content" orientation="vertical" top="0" left="0" width="100%" height="100%">
      <StackLayout orientation="vertical" ref="content">
        <AgHead :back="back" :text="title" :subtext="subtitle" @back="$emit('back')" />
        <StackLayout class="body">
          <slot name="default"></slot>
        </StackLayout>
        <AgFoot />
      </StackLayout>
    </ScrollView>
    <!--
    <AgMenu v-if="fabActions.length > 0" class="menu" v-model="menuOpen" :offsetRight="width - fabLeft - (fabSize / 2)" :offsetBottom="height - fabTop + menuOffset" :links="fabActions" :menuWidth="menuWidth" />
    <AgButton round v-if="fabVisible" class="fab" :left="fabLeft" :top="fabTop" :icon="fabIcon" :color="fabColor" :iconSize="fabIconSize" :style="'top: ' + fabTop + 'px; left: ' + fabLeft + 'px;'" @tap="fabAction" @click="fabAction" />
    -->
  </AbsoluteLayout>
</template>

<script>

import env from '@/helpers/env'
// import { colors } from '@/helpers/ui'
import AgHead from '@/components/Head'
import AgFoot from '@/components/Foot'
// import AgMenu from '@/components/Menu'

export default {
  components: {
    AgFoot,
    AgHead,
    // AgMenu
  },
  props: {
    title: {
      type: String,
      default: '[title]'
    },
    subtitle: {
      type: String,
      default: ''
    },
    back: {
      type: Boolean,
      default: false
    },
    // fab: {
    //   type: Boolean,
    //   default: false
    // },
    // fabColor: {
    //   type: String,
    //   default: colors.accent
    // },
    // fabIcon: {
    //   type: String,
    //   default: 'agila:paw'
    // },
    // fabIconSize: {
    //   type: [Number, String],
    //   default: 26
    // },
    // fabActions: {
    //   type: Array,
    //   default () {
    //     return []
    //   }
    // }
  },
  data: () => ({
    width: 0,
    height: 0,
    contentOffset: 0,
    // fabSize: 60,
    // fabRight: 30,
    // fabBottom: 30,
    menuOpen: false,
    menuWidth: 300,
    menuHeight: 70,
    menuOffset: 30
  }),
  computed: {
    classes () {
      let classes = ['base']

      if (this.menuOpen) {
        classes.push('menu-open')
      }

      return classes.join(' ')
    },
    // fabVisible () {
    //   return this.isActive && this.fab
    // },
    // fabLeft () {
    //   let left = this.width - this.fabSize - this.fabRight - this.contentOffset

    //   if (left > 0) return left

    //   return 9999
    // },
    // fabTop () {
    //   let height = (env.isIos && env.isNative ? env.getAppHeight() - this.menuHeight : this.height)
    //   let top =  height - this.fabSize - this.fabBottom

    //   if (top > 0) return top

    //   return 9999
    // },
    isActive () {
      return !this.$store?.state.settings.id || this.$store?.state.settings.status
    }
  },
  methods: {
    setSizeNative ({ object }) {
      let size = object.getActualSize()

      this.width = Math.round(size.width)
      this.height = Math.round(size.height)
    },
    setSizeWeb() {
      if (this.$refs.content) {
        this.contentOffset = this.$refs.content.$el.offsetLeft
      }

      if (this.$el) {
        this.width = this.$el.offsetWidth
        this.height = this.$el.offsetHeight
      }
    },
    fabAction () {
      this.$emit('fab')

      this.menuOpen = !this.menuOpen
    }
  },
  mounted () {
    if (env.isNative) {
      this.nativeView.on('layoutChanged', this.setSizeNative)
    }
    else {
      window.addEventListener('resize', this.setSizeWeb)

      setTimeout(() => {
        this.setSizeWeb()
      }, 100)
    }
  }
}

</script>

<style scoped lang="scss">

.base {
  width: 100%;
  height: 100%;
}

.ns-ios,
.ns-android {
  .head::v-deep > *,
  .body::v-deep > *,
  .foot::v-deep > * {
    margin: 0 20 20 20;
  }

  .body::v-deep > .no-margin {
    margin: 0;
  }
}

html {
  .fab {
    position: absolute;
  }

  .scroll-content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .base {
    overflow: hidden;
  }

  .head {
    padding-top: env(safe-area-inset-top);
  }

  .head::v-deep > *,
  .body::v-deep > *,
  .foot::v-deep > * {
    margin: 0 20px 20px 20px;
  }

  .body::v-deep > .no-margin {
    margin: 0;
  }

  @media (min-width: 800px) {
    .scroll-content {
      left: 160px;
    }

    .head::v-deep > *,
    .body::v-deep > *,
    .foot::v-deep > * {
      margin: 0 40px 40px 40px;
    }
  }
}

</style>